import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Credentials,Login,User } from 'src/app/auth/modelos/login.interface'; 
//import { JwtResponseI } from '../model/jwt-response';
import { tap } from 'rxjs/operators';
import { Observable,BehaviorSubject } from 'rxjs';
//import { UserI } from '../model/user';



@Injectable()

export class AuthService {
  AUTH_SERVER: string='http://localhost:4200/servidor';
  authSubject = new BehaviorSubject(false);
  private token?: string;


    constructor(
      private httpClient: HttpClient
      
      ) { }
  
    loginUser(credentials: Credentials): Observable<Login> {
      return this.httpClient.get<Login>(`http://localhost:4200/servidor/api/usuarios/validarusuarios/`);
    }

    // register(user:UserI):Observable<JwtResponseI>{

    //   return this.httpClient.post<JwtResponseI>(`${this.AUTH_SERVER}/register`,
    //   user).pipe(tap(
    //     (res:JwtResponseI)=>{
    //       if (res){
    //         // guardar token
    //         this.saveToken(res.dataUser.accessToken,res.dataUser.expiresIn);

    //       }
    //     }
    //   ))
    // }


    // login(user:UserI):Observable<JwtResponseI>{

    //   return this.httpClient.post<JwtResponseI>(`${this.AUTH_SERVER}/login`,
    //   user).pipe(tap(
    //     (res:JwtResponseI)=>{
    //       if (res){
    //         // login
    //         this.saveToken(res.dataUser.accessToken,res.dataUser.expiresIn);
    //       }
    //     }
    //   ))
    // }



logout(){
  this.token="";
  localStorage.removeItem("ACCESS_TOKEN");
  localStorage.removeItem("EXPIRES_IN");
}

private saveToken(token:string,expiresIn:string): void{
  localStorage.setItem("ACCESS_TOKEN",token);
  localStorage.setItem("EXPIRES_IN",expiresIn);
  this.token=token;

}

private getToken(): string{
  if(!this.token){
    this.token = localStorage.getItem("ACCESS_TOKEN")+"";

  }
  return this.token;
}


  }